import getSubscriptionManagerState from './subscription-manager-state';
import type { RootState } from '../types/store';
import type currentPackage from '../reducers/current-package';

function getCurrentPackage(state: RootState): ReturnType<typeof currentPackage> {
  return getSubscriptionManagerState(state).currentPackage;
}

export default getCurrentPackage;
